<ng-container *ngIf="!icon">
  <button mat-button type="button" class="{{'btn' + flair}}" [disabled]="disabled" (click)="onClick.emit($event)">
    <span><ng-content></ng-content></span>
    <mat-icon *ngIf="!!tooltip"
              iconPositionEnd
              class="tooltip-icon"
              [class.tooltip-white]="flair === 'Negative'"
              svgIcon="tooltip"
              [matTooltip]="tooltip"
    ></mat-icon>
  </button>
</ng-container>
<button *ngIf="icon" mat-icon-button [disabled]="disabled" (click)="onClick.emit($event)">
  <mat-icon [matTooltip]="tooltip">{{icon}}</mat-icon>
</button>
